export default {"premSel":"premSel","enhEff":"enhEff","higQuaAff":"higQuaAff","compSat":"compSat","seaTem":"seaTem","genOne":"genOne","pptTem":"pptTem","imgMat":"imgMat","choIco":"choIco","goWor":"goWor"}
